export const handleFirebaseError = (error: any, context: string) => {
  console.error(`${context} error:`, error);
  
  if (error?.code === 'permission-denied') {
    console.warn(`Permission denied for ${context} - user may not have access`);
    return { success: false, error: 'Permission denied' } as const;
  }
  
  if (error?.code === 'unavailable') {
    console.warn(`Firebase unavailable for ${context} - retrying later`);
    return { success: false, error: 'Service temporarily unavailable' } as const;
  }
  
  return { success: false, error: (error as any)?.message || 'Unknown error' } as const;
};

export const withErrorHandling = async <T>(fn: () => Promise<T>, context: string) => {
  try {
    const result = await fn();
    return { success: true, data: result } as const;
  } catch (error) {
    return handleFirebaseError(error, context);
  }
};




